import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { TimeWarning, CreateTimeWarningDto } from 'types';

export const createTimeWarning = ({
  data,
}: {
  data: CreateTimeWarningDto;
}): Promise<TimeWarning> => {
  return axios.post(`/api/time-warnings`, data);
};

type UseCreateTimeWarningOptions = {
  analyzerId?: number;
  config?: MutationConfig<typeof createTimeWarning>;
};

export const useCreateTimeWarning = ({
  config,
  analyzerId,
}: UseCreateTimeWarningOptions) => {
  return useMutation({
    onMutate: async (newTimeWarning) => {
      await queryClient.cancelQueries(['analyzers', analyzerId, 'timeWarning']);

      const previousTimeWarning = queryClient.getQueryData<TimeWarning>([
        'analyzers',
        analyzerId,
        'timeWarning',
      ]);

      queryClient.setQueryData(
        ['analyzers', analyzerId, 'timeWarning'],
        newTimeWarning.data
      );

      return { previousTimeWarning };
    },
    onError: (_, __, context: any) => {
      if (context?.previousTimeWarning) {
        queryClient.setQueryData(
          ['analyzers', analyzerId, 'timeWarning'],
          context.previousTimeWarning
        );
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['analyzer', analyzerId]);
    },
    ...config,
    mutationFn: createTimeWarning,
  });
};
